/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Demo_PauseInputs */

const en_why_listening_demo_pause = /** @type {(inputs: Why_Listening_Demo_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause the Listening demo`)
};

const es_why_listening_demo_pause = /** @type {(inputs: Why_Listening_Demo_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausar la demo de Listening`)
};

/**
* | output |
* | --- |
* | "Pause the Listening demo" |
*
* @param {Why_Listening_Demo_PauseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_demo_pause = /** @type {((inputs?: Why_Listening_Demo_PauseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Demo_PauseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_demo_pause(inputs)
	return en_why_listening_demo_pause(inputs)
});